<template>
    <div class="home-container">
        <nav-list :clickIndex="clickIndex"></nav-list>
        <div class="middle">
            <div class="con_div">
                <div class="con_div_text01">
                    <p class="title">总开户数</p>
                    <p class="org">{{ indexObj.kaihu_allcount }}</p>
                </div>
                <div class="con_div_text01">
                    <p class="title">本月累计开户数</p>
                    <p class="org" :class="scrollView ? 'org-up' : 'org-down'">
                        {{ indexObj.kaihu_monthcount }}
                    </p>
                </div>
                <div class="con_div_text01">
                    <p class="title">今日预约数</p>
                    <p class="org" :class="scrollView ? 'org-up' : 'org-down'">
                        {{ indexObj.kaihu_today_yuyue_count }}
                    </p>
                </div>
                <div class="con_div_text01">
                    <p class="title">今日完成数</p>
                    <p class="org">{{ indexObj.kaihu_today_deal_count }}</p>
                </div>

                <div class="con_div_text01">
                    <p class="title">累计合作财务公司数量</p>
                    <p class="org">{{ indexObj.kaihucompany_allcount }}</p>
                </div>
                <div class="con_div_text01">
                    <p class="title">在线网点数</p>
                    <p class="org">{{ indexObj.online_bank }}</p>
                </div>
                <div class="con_div_text01">
                    <p class="title">今日新增财务公司数量</p>
                    <p class="org">{{ indexObj.kaihucompany_todaycount }}</p>
                </div>
            </div>
        </div>
        <div class="home-content">
            <div class="div_any02">
                <div class="div_any_child div_height" style="position: relative;">
                    <div style="display: flex;justify-content: center;">
                        <div class="div_any_title"
                            style="position: relative;z-index: 999;padding: 0 20px;left: 0;width: auto;">
                            <img src="../../assets/images/title_0.png" />
                            {{ !mapProvinciaShow && !mapCityShow ? '全国' : '' }}{{ mapProvinciaShow ?
                                selectProvincia.name :
                                ''
                            }}{{ mapCityShow ? selectCity.name : '' }}开户分布图
                        </div>
                    </div>
                    <div id="mapChart" ref="mapChart" v-loading="loading" element-loading-text="地图正在生成中"
                        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.1)"
                        style="width: 100%;height: 100%;"></div>

                    <div v-if="mapProvinciaShow" class="div_any_child map_provincia_show div_height"
                        style="margin: 0;width: calc((100vw - 30px - 15px) / 2);">
                        <div ref="mapProvincia" v-loading="tableLoading" element-loading-text="地图正在生成中"
                            element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.1)"
                            style="display: inline-block;width: 100%;height: calc(100vh - 240px - 40px);">
                        </div>
                    </div>
                    <div v-if="mapCityShow" class="div_any_child map_provincia_show div_height"
                        style="margin: 0;width: calc((100vw - 30px - 15px) / 2);">
                        <div ref="mapCity" id="mapCity" v-loading="tableLoading2" element-loading-text="地图正在生成中"
                            element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.1)"
                            style="display: inline-block;width: 100%;height: calc(100vh - 240px - 40px);">
                        </div>
                    </div>
                    <i v-if="mapProvinciaShow" class="el-icon-close close-botton" @click="closeMap"></i>
                    <div v-if="mapCityShow" class="city-radio-button">
                        <el-radio-group v-model="mapCityShowType" size="small" @input="mapCityShowTypeInput">
                            <el-radio-button label="map" name="map">地图</el-radio-button>
                            <el-radio-button label="branch" name="branch">网点</el-radio-button>
                            <el-radio-button label="bank" name="bank">银行</el-radio-button>
                        </el-radio-group>
                    </div>
                </div>
            </div>

            <div style="width: 100%;position: relative;">

                <div class="div_any03 div_any_child"
                    style="position: relative;z-index: 100;padding: 20px; box-sizing: border-box;">
                    <div v-loading="loading2" element-loading-text="加载中..." element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(0, 0, 0, 0.1)" class="div_height2">
                        <div id="monActive" style="width: 100%;height: 100%;"></div>
                    </div>
                </div>

                <div class="div_any_child index_table" :style="{
                    position: tableBig ? 'fixed' : 'relative',
                    top: tableBig ? '9vh' : '',
                    left: tableBig ? '7vw' : '',
                    width: tableBig ? '86vw' : 'calc((100vw - 30px - 15px) / 2)',
                    maxWidth: tableBig ? '' : 'calc((100vw - 30px - 15px) / 2)'
                }">
                    <div class="bigicon">
                        <i :class="tableBig ? 'el-icon-bottom-right' : 'el-icon-top-left'"
                            @click="tableBig = !tableBig"></i>
                    </div>
                    <el-table :data="tableData" :height="tableBig ? '80vh' : 'calc((100vh - 240px) / 2 - 28px)'"
                        row-key="id" :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
                        default-expand-all border v-loading="tableLoading3" element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(0, 0, 0, 0.4)" @header-click="headerClick">
                        <el-table-column prop="name" label="地区">
                            <template slot-scope="scope">
                                {{ scope.row.name }}
                            </template>
                        </el-table-column>
                        <el-table-column v-for="date in dateColumns" :key="date" :label="date" :prop="date" width="60"
                            align="center">
                        </el-table-column>
                    </el-table>

                </div>
                <div class="index-map-date-picker">
                    <el-date-picker v-model="selectDate2" type="monthrange" range-separator="至" start-placeholder="开始月份"
                        end-placeholder="结束月份" value-format="yyyy-MM" @change="getDataList"
                        :picker-options="pickerOptions2">
                    </el-date-picker>
                </div>
            </div>
        </div>
        <!-- <el-dialog width="100%" :fullscreen="true" :visible.sync="dialogTableVisible4" @opened="nextGetProvincialData"
            @closed="closeMap()">
            <div v-if="mapProvinciaShow" ref="mapProvincia" v-loading="tableLoading" element-loading-text="地图正在生成中"
                element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.1)"
                style="width: calc((100vw - 30px - 15px) / 2); display: inline-block" class="div_height"></div>
        </el-dialog> -->


        <!-- <el-dialog width="100%" :fullscreen="true" :visible.sync="dialogTableVisible5" @opened="nextGetCityData"
            @closed="closeMap2()">
            <div v-if="mapCityShow" ref="mapCity" id="mapCity" v-loading="tableLoading2" element-loading-text="地图正在生成中"
                element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.1)"
                style="width: 100%; height: 100vh; display: inline-block"></div>
        </el-dialog> -->


        <el-dialog title="排行" custom-class="toptopcss" :visible.sync="topShow" width="900px" @close="topShowClose">
            <div id="toptop" style="width: 800px;height: 450px;"></div>
        </el-dialog>
    </div>
</template>
<script>
import {
    getScreenIndex,
    getMapCityIndex,
    getiptoprovince,
    getCityBankData,
    getCityBankData_new,
    getKaihuMonthCityList,
    getCityDataNew,
    get_bank_type,
    getMapJson
} from "@/api/homeIndex/homeIndex";
import "echarts/extension/bmap/bmap";
import { getallanalysedata } from "@/api/inviteIndex/inviteIndex";

import china from "@/assets/json/china.json";
import region from "@/assets/json/region.json";

import seamlessScroll from "@/components/seamlessScroll.vue";


import Provincia11 from "@/assets/json/geometryProvince/11.json";
import Provincia12 from "@/assets/json/geometryProvince/12.json";
import Provincia13 from "@/assets/json/geometryProvince/13.json";
import Provincia14 from "@/assets/json/geometryProvince/14.json";
import Provincia15 from "@/assets/json/geometryProvince/15.json";
import Provincia21 from "@/assets/json/geometryProvince/21.json";
import Provincia22 from "@/assets/json/geometryProvince/22.json";
import Provincia23 from "@/assets/json/geometryProvince/23.json";
import Provincia31 from "@/assets/json/geometryProvince/31.json";
import Provincia32 from "@/assets/json/geometryProvince/32.json";
import Provincia33 from "@/assets/json/geometryProvince/33.json";
import Provincia34 from "@/assets/json/geometryProvince/34.json";
import Provincia35 from "@/assets/json/geometryProvince/35.json";
import Provincia36 from "@/assets/json/geometryProvince/36.json";
import Provincia37 from "@/assets/json/geometryProvince/37.json";
import Provincia41 from "@/assets/json/geometryProvince/41.json";
import Provincia42 from "@/assets/json/geometryProvince/42.json";
import Provincia43 from "@/assets/json/geometryProvince/43.json";
import Provincia44 from "@/assets/json/geometryProvince/44.json";
import Provincia45 from "@/assets/json/geometryProvince/45.json";
import Provincia46 from "@/assets/json/geometryProvince/46.json";
import Provincia50 from "@/assets/json/geometryProvince/50.json";
import Provincia51 from "@/assets/json/geometryProvince/51.json";
import Provincia52 from "@/assets/json/geometryProvince/52.json";
import Provincia53 from "@/assets/json/geometryProvince/53.json";
import Provincia54 from "@/assets/json/geometryProvince/54.json";
import Provincia61 from "@/assets/json/geometryProvince/61.json";
import Provincia62 from "@/assets/json/geometryProvince/62.json";
import Provincia63 from "@/assets/json/geometryProvince/63.json";
import Provincia64 from "@/assets/json/geometryProvince/64.json";
import Provincia65 from "@/assets/json/geometryProvince/65.json";
import Provincia71 from "@/assets/json/geometryProvince/71.json";
import Provincia81 from "@/assets/json/geometryProvince/81.json";
import Provincia82 from "@/assets/json/geometryProvince/82.json";
import { cityMap } from '@/assets/json/geometryCity/china-main-city-map.js'

import navList from "@/components/navList/navList.vue";
import { color } from "echarts";

var mapBankListData = []
var mapBanksListData = []
var mapBankRes = null

var lineOpiton2 = {
    title: {
        text: "",
    },
    tooltip: {
        trigger: "axis",
    },
    legend: {
        data: ["开户数", "日均开户数"],
        textStyle: {
            color: "#fff",
        },
        left: "3%"
    },
    grid: {
        left: "3%",
        right: "4%",
        bottom: "3%",
        containLabel: true,
    },

    xAxis: {
        type: "category",
        boundaryGap: false,
        data: [],
        axisLabel: {
            textStyle: {
                color: "#fff",
            },
        },
    },
    yAxis: {
        type: "value",
        axisLabel: {
            textStyle: {
                color: "#fff",
            },
        },
    },
    series: [
        {
            name: "开户数",
            type: "line",
            stack: "yuyue",
            lineStyle: {
                color: "#0888FF",
            },
            itemStyle: {
                color: "#0888FF",
            },
            data: [],
        },
        {
            name: "日均开户数",
            type: "line",
            stack: "deal",
            lineStyle: {
                color: "#D8B100",
            },
            itemStyle: {
                color: "#D8B100",
            },
            data: [],
        }
    ],
}


export default {
    name: "homeIndex",
    components: {
        navList,
        seamlessScroll
    },
    data() {
        return {
            topShow: false,
            toptop: null,

            originalData: [],
            tableLoading3: true,
            tableData: [],
            dateColumns: [],
            loading2: true,

            selectDate2: null,
            selectDate2_clone: null,
            // 日期时间范围在一个月以内
            pickerOptions2: {
                onPick: ({ maxDate, minDate }) => {
                    // 将选中的起始月份存储在selectDate中
                    this.selectedRange2 = minDate ? minDate.getTime() : "";

                    if (minDate && !maxDate) {
                        // 记录第一次选择的日期
                        this.timeOptionRange2 = minDate;
                    }

                    if (maxDate) {
                        // 当两个日期都选择后，重置状态
                        this.selectedRange2 = "";
                        this.timeOptionRange2 = null;
                    }
                },
                disabledDate: (time) => {
                    // 限制2024年12月之前的月份
                    const limitDate = new Date(2024, 11, 1); // 2024年12月1日
                    if (time.getTime() < limitDate.getTime()) {
                        return true;
                    }
                    if (this.timeOptionRange2) {
                        // 计算12个月范围
                        const start = this.timeOptionRange2;
                        const end = new Date(start);
                        end.setMonth(start.getMonth() + 11);

                        // 只允许选择起始月份和结束月份
                        return time.getTime() !== start.getTime() &&
                            time.getTime() !== end.getTime();
                    }
                    return false;
                }
            },

            selectDate: "",
            // 日期时间范围在一个月以内
            pickerOptions: {
                onPick: ({ maxDate, minDate }) => {
                    this.selectDate = minDate.getTime();
                    if (minDate && !maxDate) {
                        this.timeOptionRange = minDate;
                    }
                    if (maxDate) {
                        this.selectDate = "";
                        this.timeOptionRange = null;
                    }
                },
                disabledDate: (time) => {
                    let timeOptionRange = this.timeOptionRange;
                    if (
                        timeOptionRange &&
                        time.getTime() === timeOptionRange.getTime()
                    )
                        return true;
                    if (this.selectDate !== "") {
                        const one = 30 * 24 * 3600 * 1000;
                        const minTime = this.selectDate - one;
                        const maxTime = this.selectDate + one;
                        return (
                            time.getTime() < minTime || time.getTime() > maxTime
                        );
                    }
                },
            },
            dialogTableVisible: false,
            provinceList: [],
            dialogType: 1,
            tableLoading: true,
            tableLoading2: true,

            clickIndex: 1,
            mapOption: {
                bmap: {
                    center: [117.27, 31.86],
                    zoom: 5,
                    roam: true,
                    mapStyle: {
                        styleJson: [
                            {
                                featureType: "water",
                                elementType: "all",
                                stylers: {
                                    color: "#044161",
                                },
                            },
                            {
                                featureType: "land",
                                elementType: "all",
                                stylers: {
                                    color: "#004981",
                                },
                            },
                            {
                                featureType: "boundary",
                                elementType: "geometry",
                                stylers: {
                                    color: "#064f85",
                                },
                            },
                            {
                                featureType: "railway",
                                elementType: "all",
                                stylers: {
                                    visibility: "off",
                                },
                            },
                            {
                                featureType: "highway",
                                elementType: "geometry",
                                stylers: {
                                    color: "#004981",
                                },
                            },
                            {
                                featureType: "highway",
                                elementType: "geometry.fill",
                                stylers: {
                                    color: "#005b96",
                                    lightness: 1,
                                },
                            },
                            {
                                featureType: "highway",
                                elementType: "labels",
                                stylers: {
                                    visibility: "off",
                                },
                            },
                            {
                                featureType: "arterial",
                                elementType: "geometry",
                                stylers: {
                                    color: "#004981",
                                },
                            },
                            {
                                featureType: "arterial",
                                elementType: "geometry.fill",
                                stylers: {
                                    color: "#00508b",
                                },
                            },
                            {
                                featureType: "poi",
                                elementType: "all",
                                stylers: {
                                    visibility: "off",
                                },
                            },
                            {
                                featureType: "green",
                                elementType: "all",
                                stylers: {
                                    color: "#056197",
                                    visibility: "off",
                                },
                            },
                            {
                                featureType: "subway",
                                elementType: "all",
                                stylers: {
                                    visibility: "off",
                                },
                            },
                            {
                                featureType: "manmade",
                                elementType: "all",
                                stylers: {
                                    visibility: "off",
                                },
                            },
                            {
                                featureType: "local",
                                elementType: "all",
                                stylers: {
                                    visibility: "off",
                                },
                            },
                            {
                                featureType: "arterial",
                                elementType: "labels",
                                stylers: {
                                    visibility: "off",
                                },
                            },
                            {
                                featureType: "boundary",
                                elementType: "geometry.fill",
                                stylers: {
                                    color: "#029fd4",
                                },
                            },
                            {
                                featureType: "building",
                                elementType: "all",
                                stylers: {
                                    color: "#1a5787",
                                },
                            },
                            {
                                featureType: "label",
                                elementType: "all",
                                stylers: {
                                    visibility: "off",
                                },
                            },
                        ],
                    },
                },
                tooltip: {
                    trigger: "item",
                    showDelay: 0,
                    transitionDuration: 0.2,
                },
                series: [
                    {
                        type: "scatter",
                        coordinateSystem: "bmap",
                        data: [],
                        encode: {
                            value: 2,
                        },
                        symbolSize: 10,
                        label: {
                            formatter: "{b}",
                            position: "right",
                        },
                        itemStyle: {
                            color: "#ddb926",
                        },
                        projection: {
                            project: function (point) {
                                console.log(point);
                                return projection(point);
                            },
                            unproject: function (point) {
                                console.log(point);
                                return projection.invert(point);
                            },
                        },
                        emphasis: {
                            label: {
                                show: true,
                            },
                        },
                    },
                    {
                        type: "scatter",
                        coordinateSystem: "bmap",
                        data: [],
                        encode: {
                            value: 2,
                        },
                        symbolSize: 10,
                        label: {
                            formatter: "{b}",
                            position: "right",
                        },
                        itemStyle: {
                            color: "#ddb926",
                        },
                        projection: {
                            project: function (point) {
                                console.log(point);
                                return projection(point);
                            },
                            unproject: function (point) {
                                console.log(point);
                                return projection.invert(point);
                            },
                        },
                        emphasis: {
                            label: {
                                show: true,
                            },
                        },
                    },
                    {
                        type: "scatter",
                        coordinateSystem: "bmap",
                        data: [],
                        encode: {
                            value: 2,
                        },
                        symbolSize: 10,
                        label: {
                            formatter: "{b}",
                            position: "right",
                        },
                        itemStyle: {
                            color: "#ddb926",
                        },
                        projection: {
                            project: function (point) {
                                console.log(point);
                                return projection(point);
                            },
                            unproject: function (point) {
                                console.log(point);
                                return projection.invert(point);
                            },
                        },
                        emphasis: {
                            label: {
                                show: true,
                            },
                        },
                    },
                    {
                        type: "scatter",
                        coordinateSystem: "bmap",
                        data: [],
                        encode: {
                            value: 2,
                        },
                        symbolSize: 10,
                        label: {
                            formatter: "{b}",
                            position: "right",
                        },
                        itemStyle: {
                            color: "#ddb926",
                        },
                        projection: {
                            project: function (point) {
                                console.log(point);
                                return projection(point);
                            },
                            unproject: function (point) {
                                console.log(point);
                                return projection.invert(point);
                            },
                        },
                        emphasis: {
                            label: {
                                show: true,
                            },
                        },
                    },
                    {
                        type: "scatter",
                        coordinateSystem: "bmap",
                        data: [],
                        encode: {
                            value: 2,
                        },
                        symbolSize: 10,
                        label: {
                            formatter: "{b}",
                            position: "right",
                        },
                        itemStyle: {
                            color: "#ddb926",
                        },
                        projection: {
                            project: function (point) {
                                console.log(point);
                                return projection(point);
                            },
                            unproject: function (point) {
                                console.log(point);
                                return projection.invert(point);
                            },
                        },
                        emphasis: {
                            label: {
                                show: true,
                            },
                        },
                    },
                    {
                        type: "scatter",
                        coordinateSystem: "bmap",
                        data: [],
                        encode: {
                            value: 2,
                        },
                        symbolSize: 10,
                        label: {
                            formatter: "{b}",
                            position: "right",
                        },
                        itemStyle: {
                            color: "#ddb926",
                        },
                        projection: {
                            project: function (point) {
                                console.log(point);
                                return projection(point);
                            },
                            unproject: function (point) {
                                console.log(point);
                                return projection.invert(point);
                            },
                        },
                        emphasis: {
                            label: {
                                show: true,
                            },
                        },
                    },
                    {
                        type: "scatter",
                        coordinateSystem: "bmap",
                        data: [],
                        encode: {
                            value: 2,
                        },
                        symbolSize: 10,
                        label: {
                            formatter: "{b}",
                            position: "right",
                        },
                        itemStyle: {
                            color: "#ddb926",
                        },
                        projection: {
                            project: function (point) {
                                console.log(point);
                                return projection(point);
                            },
                            unproject: function (point) {
                                console.log(point);
                                return projection.invert(point);
                            },
                        },
                        emphasis: {
                            label: {
                                show: true,
                            },
                        },
                    },
                    {
                        type: "effectScatter",
                        coordinateSystem: "bmap",
                        data: [],
                        encode: {
                            value: 2,
                        },
                        symbolSize: 30,
                        showEffectOn: "emphasis",
                        rippleEffect: {
                            brushType: "stroke",
                        },
                        hoverAnimation: true,
                        label: {
                            formatter: "{b}",
                            position: "right",
                            show: true,
                        },
                        itemStyle: {
                            color: "#f4e925",
                            shadowBlur: 10,
                            shadowColor: "#333",
                        },
                        zlevel: 1,
                    },
                ],
            },
            indexObj: {},
            pickerTime: "",
            loading: true,
            topData: [],
            dataType: "",
            scrollView: false,
            // 型地图
            myChart: null,
            mapProvinciaShow: false,
            mapCityShow: false,
            myChartProvincia: null,
            myChartCtiy: null,
            dialogTableVisible4: false,
            dialogTableVisible5: false,
            selectProvincia: {},
            selectCity: {},
            provinciaList: {
                北京: Provincia11,
                天津: Provincia12,
                河北: Provincia13,
                山西: Provincia14,
                内蒙古: Provincia15,
                辽宁: Provincia21,
                吉林: Provincia22,
                黑龙江: Provincia23,
                上海: Provincia31,
                江苏: Provincia32,
                浙江: Provincia33,
                安徽: Provincia34,
                福建: Provincia35,
                江西: Provincia36,
                山东: Provincia37,
                河南: Provincia41,
                湖北: Provincia42,
                湖南: Provincia43,
                广东: Provincia44,
                广西: Provincia45,
                海南: Provincia46,
                重庆: Provincia50,
                四川: Provincia51,
                贵州: Provincia52,
                云南: Provincia53,
                西藏: Provincia54,
                陕西: Provincia61,
                甘肃: Provincia62,
                青海: Provincia63,
                宁夏: Provincia64,
                新疆: Provincia65,
                台湾: Provincia71,
                香港: Provincia81,
                澳门: Provincia82
            },
            cityList: [],

            // 用户行为数据
            analysedata: [],
            loadingList: true,
            analysPage: 1,
            analysTotal: 0,

            mapCityShowType: 'map',
            cityOptions: {
                title: {
                    text: '',
                    top: '8%',
                    left: '8%',
                    textStyle: {
                        fontSize: 14,
                        fontWeight: 300,
                        color: '#000'
                    }
                },
                tooltip: {
                    triggerOn: "mousemove", //mousemove、click
                    padding: 8,
                    borderWidth: 1,
                    borderColor: "#409eff",
                    backgroundColor: "rgba(255,255,255,0.7)",
                    textStyle: {
                        color: "#000000",
                        fontSize: 13,
                    },
                    position: function (point, _params, _dom, _rect, size) {
                        // 让鼠标位于 tooltip 的下三分之一处
                        return [point[0] + 15, point[1] - size.contentSize[1] * 2 / 3];
                    },
                    // 数据格式化
                    formatter: function (e, t, n) {
                        let data = e.data;
                        let context = `
                            <div>
                                <p><b style="font-size:15px;">${data.name}</b></p>
                                <p class="tooltip_style"><span class="tooltip_left">开户数量：</span><span class="tooltip_right">${data.value[2]}</span></p>
                            </div>
                            `;
                        return context;
                    },
                },
                legend: {
                    top: '10',
                    textStyle: {
                        color: '#ffffff',
                    },
                    data: []
                },
                // legend: {
                //     orient: 'vertical',
                //     top: '9%',
                //     left: '5%',
                //     icon: 'circle',
                //     data: [],
                //     selectedMode: 'single',
                //     selected: {},
                //     itemWidth: 12,
                //     itemHeight: 12,
                //     itemGap: 30,
                //     inactiveColor: '#b6d7ff',
                //     textStyle: {
                //         color: '#ec808d',
                //         fontSize: 14,
                //         fontWeight: 300,
                //         padding: [0, 0, 0, 15]
                //     }
                // },
                // visualMap: {

                // },
                geo: {
                    map: '',
                    roam: true, // 不开启缩放和平移
                    zoom: 1.2, // 视角缩放比例
                    layoutSize: "100%", //保持地图宽高比
                    label: {
                        normal: {
                            show: true,
                            fontSize: 10,
                            color: '#fff'
                        },
                        emphasis: {
                            show: false,
                            color: 'blue',
                        }
                    },
                    itemStyle: {
                        areaColor: '#7ED3FF',
                        // normal: {
                        //     borderColor: 'rgba(0, 0, 0, 0.2)'
                        // },
                        // emphasis: {
                        //     disabled: true,
                        //     areaColor: '#1C95FF', // 鼠标选择区域颜色
                        //     shadowOffsetX: 0,
                        //     shadowOffsetY: 0,
                        //     shadowBlur: 0,
                        //     borderWidth: 0
                        // }
                    },
                    emphasis: {
                        disabled: true,
                        label: {
                            show: false
                        }
                    }
                },
                series: [],
                cityJSON: {},
                cityName: '',

                bankDictionary: null
            },


            tableBig: false,

            //权限配置
            permissionAuth: null
        };
    },
    watch: {},
    created() {
        this.getIndex();
        let startDate = this.$moment().format("YYYY-MM-DD");
        let endDate = this.$moment().add(1, "days").format("YYYY-MM-DD");
        let monDate = this.$moment().subtract(1, "months").format("YYYY-MM-DD");
        this.pickerTime = [startDate, endDate];
        this.selectDate = [monDate, startDate];
        this.selectDate2 = [this.$moment().subtract(11, "months").format("YYYY-MM"), this.$moment().format("YYYY-MM")];
        this.permissionAuth = window.localStorage.getItem('auth')
    },
    mounted() {
        // this.getallanalysedata()
        this.$nextTick(() => {
            this.getMap();
            this.getMonList()
        });
        this.getWebSocket();
        this.get_bank_type()
    },
    props: [],
    computed: {
        // 使用计算属性转换数据
        bankCoordinates() {
            const result = {};
            this.cityList.forEach(bank => {
                // 以银行名称为键，[经度, 纬度]为值
                result[bank.bank_name] = [bank.lng, bank.lat];
            });
            return result;
        }
    },
    methods: {

        topShowClose() {
            if (this.toptop) {
                try {
                    this.toptop.clear()
                } catch (error) {

                }
                this.toptop = null
            }
        },

        headerClick(column, event) {
            let citydata = null
            for (let item of this.originalData) {
                if (item.date == column.label) {
                    citydata = item.citydata
                    break
                }
            }
            console.log(citydata)
            const list = citydata.sort((a, b) => a.data - b.data)
            let yData = []
            let sData = []
            for (let item of list) {
                yData.push(item.city)
                sData.push({ value: item.data })
            }
            var option = {
                title: {
                    text: ''
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: { show: false },
                xAxis: {
                    type: 'value',
                    boundaryGap: [0, 0.01],
                    axisLabel: {
                        color: '#ffffff'
                    }
                },
                yAxis: {
                    type: 'category',
                    data: yData,
                    axisLabel: {
                        color: '#ffffff',
                        formatter: function (value) {
                            console.log(value)
                            return value.length > 8 ? value.slice(0, 8) + '...' : value;
                        }
                    }
                },
                grid: {
                    left: '112px'   // 增加左侧空白，防止长标签被裁剪
                },
                series: [
                    {
                        name: '开户数',
                        type: 'bar',
                        data: sData
                    }
                ]
            };
            this.topShow = true
            setTimeout(() => {

                this.toptop = this.$echarts.init(document.getElementById('toptop'))
                this.$nextTick(() => {
                    this.toptop.setOption(option);
                })
            }, 700)

        },



        getDataList(e = null) {
            console.log(this.selectDate2)
            if (this.selectDate2 && this.selectDate2[0] == this.selectDate2[1]) {
                this.selectDate2 = this.selectDate2_clone
                return
            }
            const now = new Date();
            const currentYear = now.getFullYear();
            const currentMonth = now.getMonth() + 1;
            const currentMonthStr = `${currentYear}-${currentMonth.toString().padStart(2, '0')}`;
            if (this.selectDate2 && this.selectDate2[0] > currentMonthStr) {
                this.$confirm('开始时间不能大于当前时间', '提示', {
                    confirmButtonText: '确定',
                    showCancelButton: false,
                    type: 'error'
                }).then(() => {
                    this.selectDate2 = this.selectDate2_clone
                })
            } else {
                this.selectDate2_clone = this.selectDate2
                //this.getMap()
                this.mapCityShowType = 'map'
                if (this.selectDate2) this.getMonList()
                if (this.mapProvinciaShow) this.nextGetProvincialData()
                if (this.mapCityShow) this.nextGetCityData()
            }
        },

        // 获取滚动文字数据
        getallanalysedata() {
            getallanalysedata().then((res) => {
                if (res.data.code == 1) {
                    for (let item of res.data.data) {
                        this.analysedata.push({
                            mName: item.data,
                            username: item.username,
                            date: item.createtime_text,
                        });
                    }
                    this.loadingList = false
                }
            });
        },

        getMap() {
            let params = {}
            // if (this.selectDate2 && this.selectDate2.length > 0) {
            //     params.start_date = this.selectDate2[0]
            //     params.end_date = this.selectDate2[1]
            // }
            getiptoprovince(params).then((res) => {
                console.log(res, 'resresres')
                let arr = [];
                for (let val in res.data.data) {
                    console.log(res.data.data[val], 'res.data.data[val].province_data')
                    let obj = {
                        name: res.data.data[val].province,
                        value: res.data.data[val].reservation_num,
                        total_companies: res.data.data[val].total_companies,
                        total_companycount: res.data.data[val].total_companycount,
                        total_individuals: res.data.data[val].total_individuals,
                        total_register: res.data.data[val].total_register,
                        bank_unit_price: res.data.data[val].bank_unit_price,
                        total_netprofit: res.data.data[val].total_netprofit,
                        total_income: res.data.data[val].total_income,
                        total_money: res.data.data[val].total_money,
                        unit_cost: res.data.data[val].unit_cost,
                        unit_profit: res.data.data[val].unit_profit,

                        total_partner_money: res.data.data[val].total_partner_money,
                        netprofit: res.data.data[val].netprofit,
                        cac: res.data.data[val].cac,
                        cpc: res.data.data[val].cpc,
                        total_sales_personnel_cost: res.data.data[val].total_sales_personnel_cost,
                        total_related_expenses: res.data.data[val].total_related_expenses,
                        total_customer_personnel_cost: res.data.data[val].total_customer_personnel_cost,
                        total_operating_cost: res.data.data[val].total_operating_cost,
                        profit: res.data.data[val].profit,
                        permissionAuth: window.localStorage.getItem('auth')

                    };
                    arr.push(obj);
                }
                arr.push(
                    {
                        name: "台湾", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_netprofit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, 
                        total_partner_money: 0,
                        netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        profit: 0,
                        permissionAuth: 0
                    },
                    {
                        name: "南海诸岛",
                        value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_netprofit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0,
                        total_partner_money: 0,
                        netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        profit: 0,
                        permissionAuth: 0
                    },
                    {
                        name: "上海",
                        value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_netprofit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, 
                        total_partner_money: 0,
                        netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        profit: 0,
                        permissionAuth: 0
                    },
                    {
                        name: "湖北",
                        value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_netprofit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, 
                        total_partner_money: 0,
                        netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        profit: 0,
                        permissionAuth: 0
                    },
                    {
                        name: "云南", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_netprofit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, 
                        total_partner_money: 0,
                        netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        profit: 0,
                        permissionAuth: 0
                    },
                    {
                        name: "内蒙古", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_netprofit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, 
                        total_partner_money: 0,
                        netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        profit: 0,
                        permissionAuth: 0
                    },
                    {
                        name: "北京", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_netprofit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, 
                        total_partner_money: 0,
                        netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        profit: 0,
                        permissionAuth: 0
                    },
                    {
                        name: "吉林", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_netprofit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, 
                        total_partner_money: 0,
                        netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        profit: 0,
                        permissionAuth: 0
                    },
                    {
                        name: "天津", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_netprofit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, 
                        total_partner_money: 0,
                        netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        profit: 0,
                        permissionAuth: 0
                    },
                    {
                        name: "宁夏", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_netprofit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, 
                        total_partner_money: 0,
                        netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        profit: 0,
                        permissionAuth: 0
                    },
                    {
                        name: "山东", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_netprofit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, 
                        total_partner_money: 0,
                        netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        profit: 0,
                        permissionAuth: 0
                    },
                    {
                        name: "山西", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_netprofit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, 
                        total_partner_money: 0,
                        netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        profit: 0,
                        permissionAuth: 0
                    },
                    {
                        name: "广东", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_netprofit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, 
                        total_partner_money: 0,
                        netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        profit: 0,
                        permissionAuth: 0
                    },
                    {
                        name: "广西", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_netprofit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, 
                        total_partner_money: 0,
                        netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        profit: 0,
                        permissionAuth: 0
                    },
                    {
                        name: "新疆", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_netprofit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, 
                        total_partner_money: 0,
                        netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        profit: 0,
                        permissionAuth: 0
                    },
                    {
                        name: "江苏", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_netprofit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, 
                        total_partner_money: 0,
                        netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        profit: 0,
                        permissionAuth: 0
                    },
                    {
                        name: "江西", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_netprofit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, 
                        total_partner_money: 0,
                        netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        profit: 0,
                        permissionAuth: 0
                    },
                    {
                        name: "河北", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_netprofit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, 
                        total_partner_money: 0,
                        netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        profit: 0,
                        permissionAuth: 0
                    },
                    {
                        name: "河南", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_netprofit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, 
                        total_partner_money: 0,
                        netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        profit: 0,
                        permissionAuth: 0
                    },
                    {
                        name: "浙江", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_netprofit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, 
                        total_partner_money: 0,
                        netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        profit: 0,
                        permissionAuth: 0
                    },
                    {
                        name: "海南", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_netprofit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, 
                        total_partner_money: 0,
                        netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        profit: 0,
                        permissionAuth: 0
                    },
                    {
                        name: "湖南", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_netprofit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, 
                        total_partner_money: 0,
                        netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        profit: 0,
                        permissionAuth: 0
                    },
                    {
                        name: "甘肃", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_netprofit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, 
                        total_partner_money: 0,
                        netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        profit: 0,
                        permissionAuth: 0
                    },
                    {
                        name: "福建", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_netprofit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, 
                        total_partner_money: 0,
                        netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        profit: 0,
                        permissionAuth: 0
                    },
                    {
                        name: "西藏", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_netprofit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, 
                        total_partner_money: 0,
                        netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        profit: 0,
                        permissionAuth: 0
                    },
                    {
                        name: "贵州", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_netprofit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0,
                        total_partner_money: 0,
                        netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        profit: 0,
                        permissionAuth: 0
                    },
                    {
                        name: "辽宁", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_netprofit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, 
                        total_partner_money: 0,
                        netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        profit: 0,
                        permissionAuth: 0
                    },
                    {
                        name: "重庆", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_netprofit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, 
                        total_partner_money: 0,
                        netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        profit: 0,
                        permissionAuth: 0
                    },
                    {
                        name: "陕西", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_netprofit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, 
                        total_partner_money: 0,
                        netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        profit: 0,
                        permissionAuth: 0
                    },
                    {
                        name: "青海", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_netprofit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, 
                        total_partner_money: 0,
                        netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        profit: 0,
                        permissionAuth: 0
                    },
                    {
                        name: "黑龙江", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_netprofit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0,
                        total_partner_money: 0,
                        netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        profit: 0,
                        permissionAuth: 0
                    },
                    {
                        name: "四川", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_netprofit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0,
                        total_partner_money: 0,
                        netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        profit: 0,
                        permissionAuth: 0
                    },
                );
                this.topData = arr;
                console.log(this.topData, 'this.topDatathis.topData')
                this.initEchartMap();
            });
        },
        // 型地图初始化
        initEchartMap() {
            this.$echarts.registerMap("china", china);
            this.myChart = this.$echarts.init(this.$refs.mapChart, null, {
                renderer: "svg",
            });
            this.myChart.off("click");

            //echart 配制option
            var options = {
                tooltip: {
                    triggerOn: "mousemove", //mousemove、click
                    padding: 8,
                    borderWidth: 1,
                    borderColor: "#000",
                    backgroundColor: "#000",
                    textStyle: {
                        color: "#000000",
                        fontSize: 13,
                    },
                    position: function (point, _params, _dom, _rect, size) {
                        // 让鼠标位于 tooltip 的下三分之一处
                        return [point[0] + 15, point[1] - size.contentSize[1] * 4 / 5];
                    },
                    formatter: function (e, t, n) {
                        let data = e.data;
                        let context = `
                            <div>
                                <p><b style="font-size:15px;"><span class="tooltip_left">省份：</span><span class="tooltip_right">${data.name}</span></b></p>
                                <p class="tooltip_style"><span class="tooltip_left">开户数：</span><span class="tooltip_right">${data.value}</span></p>
                                ${data.permissionAuth == 1 ? `<p class="tooltip_style"><span class="tooltip_left">新注册公司：</span><span class="tooltip_right">${data.total_companies}</span></p>` : ''}
                                ${data.permissionAuth == 1 ? `<p class="tooltip_style"><span class="tooltip_left">新注册个体户：</span><span class="tooltip_right">${data.total_individuals}</span></p>` : ''}
                                ${data.permissionAuth == 1 ? `<p class="tooltip_style"><span class="tooltip_left">新注册合计：</span><span class="tooltip_right">${data.total_register}</span></p>` : ''}  
                                ${data.permissionAuth == 1 ? `<p class="tooltip_style"><span class="tooltip_left">财务公司数量：</span><span class="tooltip_right">${data.total_companycount}</span></p>` : ''}
                                ${data.permissionAuth == 1 ? `<p class="tooltip_style"><span class="tooltip_left">总收入：</span><span class="tooltip_right">${data.total_income}</span></p>` : ''}
                                ${data.permissionAuth == 1 ? `<p class="tooltip_style"><span class="tooltip_left">总基础成本：</span><span class="tooltip_right">${data.total_money}</span></p>` : ''}
                                ${data.permissionAuth == 1 ? `<p class="tooltip_style"><span class="tooltip_left">总基础毛利：</span><span class="tooltip_right">${data.total_netprofit}</span></p>` : ''}
                                ${data.permissionAuth == 1 ? `<p class="tooltip_style"><span class="tooltip_left">合伙人提成：</span><span class="tooltip_right">${data.total_partner_money}</span></p>` : ''}
                                ${data.permissionAuth == 1 ? `<p class="tooltip_style"><span class="tooltip_left">总毛利（已扣合伙人）：</span><span class="tooltip_right">${data.netprofit}</span></p>` : ''}
                                ${data.permissionAuth == 1 ? `<p class="tooltip_style"><span class="tooltip_left">银行单价：</span><span class="tooltip_right">${data.bank_unit_price}</span></p>` : ''}
                                ${data.permissionAuth == 1 ? `<p class="tooltip_style"><span class="tooltip_left">单客基础成本：</span><span class="tooltip_right">${data.unit_cost}</span></p>` : ''}
                                ${data.permissionAuth == 1 ? `<p class="tooltip_style"><span class="tooltip_left">单客基础毛利：</span><span class="tooltip_right">${data.unit_profit}</span></p>` : ''}
                                ${data.permissionAuth == 1 ? `<p class="tooltip_style"><span class="tooltip_left">单客成本（已计合伙人）：</span><span class="tooltip_right">${data.cac}</span></p>` : ''}
                                ${data.permissionAuth == 1 ? `<p class="tooltip_style"><span class="tooltip_left">单客毛利（已扣合伙人）：</span><span class="tooltip_right">${data.cpc}</span></p>` : ''}
                                ${data.permissionAuth == 1 ? `<p class="tooltip_style"><span class="tooltip_left">销售人员成本：</span><span class="tooltip_right">${data.total_sales_personnel_cost}</span></p>` : ''}
                                ${data.permissionAuth == 1 ? `<p class="tooltip_style"><span class="tooltip_left">相关费用：</span><span class="tooltip_right">${data.total_related_expenses}</span></p>` : ''}
                                ${data.permissionAuth == 1 ? `<p class="tooltip_style"><span class="tooltip_left">客服人员成本：</span><span class="tooltip_right">${data.total_customer_personnel_cost}</span></p>` : ''}
                                ${data.permissionAuth == 1 ? `<p class="tooltip_style"><span class="tooltip_left">运营成本合计：</span><span class="tooltip_right">${data.total_operating_cost}</span></p>` : ''}
                                ${data.permissionAuth == 1 ? `<p class="tooltip_style"><span class="tooltip_left">开户项目利润：</span><span class="tooltip_right">${data.profit}</span></p>` : ''}
                            </div>
                            `;
                        return context;
                    },
                },
                visualMap: {
                    show: true,
                    left: 26,
                    bottom: 40,
                    showLabel: true,
                    textStyle: {
                        color: "#ffffff",
                    },
                    pieces: [
                        {
                            gte: 5000,
                            label: ">= 5000",
                            color: "#070093",
                        },
                        {
                            gte: 1000,
                            lt: 4999,
                            label: "500 - 999",
                            color: "#1c3fbf",
                        },
                        {
                            gte: 500,
                            lt: 999,
                            label: "100 - 499",
                            color: "#1482e5",
                        },
                        {
                            gte: 100,
                            lt: 499,
                            label: "50 - 99",
                            color: "#70b4eb",
                        },
                        {
                            gte: 10,
                            lt: 99,
                            label: "10 - 50",
                            color: "#b4e0f3",
                        },
                        {
                            lt: 10,
                            label: "<10",
                            color: "#ffffff",
                        },
                    ],
                },
                geo: {
                    map: "china",
                    scaleLimit: {
                        min: 1,
                        max: 2,
                    },
                    zoom: 1,
                    top: 60,
                    layoutSize: "100%", //保持地图宽高比
                    label: {
                        normal: {
                            show: false,
                            fontSize: "12",
                            color: "rgba(0,0,0,0)",
                        },
                        emphasis: {
                            show: true,
                            position: "inside",
                            textStyle: {
                                color: "rgba(144,1,34,1)",
                            },
                        },
                    },
                    itemStyle: {
                        normal: {
                            //shadowBlur: 50,
                            //shadowColor: 'rgba(0, 0, 0, 0.2)',
                            borderColor: "rgba(0, 0, 0, 0.2)",
                            areaColor: "#1955a4",
                        },
                        emphasis: {
                            areaColor: "#f2d5ad",
                            shadowOffsetX: 0,
                            shadowOffsetY: 0,
                            borderWidth: 0,
                        },
                    },
                },
                series: [
                    {
                        name: "成果预览",
                        type: "map",
                        geoIndex: 0,
                        data: this.topData,
                    },
                ],
            };

            this.myChart.clear();
            this.myChart.setOption(options);
            this.myChart.resize();
            let that = this;
            //地图的点击事件 ，钻取到市我就不举例了，类似的方法，点击事件可以获取到当前点击的省份的数据；
            this.myChart.on("click", function (params) {
                console.log(params, '地图点击事件')
                if (params.value != 0) {
                    // that.dialogTableVisible4 = true;
                    that.selectProvincia = params;
                    that.mapProvinciaShow = true;
                    that.tableLoading = true
                    setTimeout(() => {
                        that.nextGetProvincialData()
                        that.getMonList()
                        that.getIndex() // 刷新首页数据，传递省份参数
                    }, 600)
                }
            });

            this.loading = false;

            // document.getElementById("mapChart")
        },

        nextGetProvincialData() {
            this.$nextTick(() => {
                this.getProvincialData();
            });
        },

        nextGetCityData() {
            this.$nextTick(() => {
                this.getCityData();
            });
        },

        closeMap() {
            if (this.mapCityShow) {
                this.mapCityShowType = 'map'
                this.mapCityShow = false;
            }
            else
                this.mapProvinciaShow = false;
            this.getMonList()
            this.getIndex() // 关闭地图时刷新首页数据，恢复全国数据
        },

        closeMap2() {
            this.mapCityShow = false;
            this.mapCityShowType = 'map'

        },

        // 获取省一级数据
        getProvincialData() {
            console.log("获取省级数据，展示在弹窗上");
            this.tableLoading = true;
            let params = {
                province: this.selectProvincia.name
            }
            // if (this.selectDate2 && this.selectDate2.length > 0) {
            //     params.start_date = this.selectDate2[0]
            //     params.end_date = this.selectDate2[1]
            // }
            getMapCityIndex(params).then((res) => {
                this.provinceList = [];
                let pList = [];
                for (let val in res.data.data) {
                    let obj = {
                        name: res.data.data[val].city,
                        bank_count: res.data.data[val].bank_count,
                        value: res.data.data[val].reservation_num,
                        total_companies: res.data.data[val].total_companies,
                        total_companycount: res.data.data[val].total_companycount,
                        total_individuals: res.data.data[val].total_individuals,
                        total_register: res.data.data[val].total_register,
                        bank_unit_price: res.data.data[val].bank_unit_price,
                        total_netprofit: res.data.data[val].total_netprofit,
                        total_income: res.data.data[val].total_income,
                        total_money: res.data.data[val].total_money,
                        unit_cost: res.data.data[val].unit_cost,
                        unit_profit: res.data.data[val].unit_profit,

                        total_partner_money: res.data.data[val].total_partner_money,
                        netprofit: res.data.data[val].netprofit,
                        cac: res.data.data[val].cac,
                        cpc: res.data.data[val].cpc,
                        total_sales_personnel_cost: res.data.data[val].total_sales_personnel_cost,
                        total_related_expenses: res.data.data[val].total_related_expenses,
                        total_customer_personnel_cost: res.data.data[val].total_customer_personnel_cost,
                        total_operating_cost: res.data.data[val].total_operating_cost,
                        profit: res.data.data[val].profit,
                        permissionAuth: window.localStorage.getItem('auth')
                    };
                    pList.push(val.city);
                    this.provinceList.push(obj);
                }
                if (this.provinceList.length > 0) {
                    let features =
                        this.provinciaList[this.selectProvincia.name].features;
                    for (let item of features) {
                        console.log(item);
                        if (!pList.includes(item.properties.name)) {
                            this.provinceList.push({
                                name: item.properties.name,
                                value: 0,
                                bank_count: 0,
                                total_companies: 0,
                                total_companycount: 0,
                                total_individuals: 0,
                                total_register: 0,
                                bank_unit_price: 0,
                                total_netprofit: 0,
                                total_income: 0,
                                total_money: 0,
                                unit_cost: 0,
                                unit_profit: 0,

                                total_partner_money: 0,
                                netprofit: 0,
                                cac: 0,
                                cpc: 0,
                                total_sales_personnel_cost: 0,
                                total_related_expenses: 0,
                                total_customer_personnel_cost: 0,
                                total_operating_cost: 0,
                                profit: 0,
                                permissionAuth: window.localStorage.getItem('auth')

                            });
                        }
                    }
                    console.log(this.provinceList, '省级数据');
                    this.$echarts.registerMap(
                        "provincia",
                        this.provinciaList[this.selectProvincia.name]
                    );
                    this.myChartProvincia = this.$echarts.init(
                        this.$refs.mapProvincia,
                        null,
                        {
                            renderer: "svg",
                        }
                    );
                    this.myChartProvincia.off("click");

                    var options = {
                        tooltip: {
                            triggerOn: "mousemove", //mousemove、click
                            padding: 8,
                            borderWidth: 1,
                            borderColor: "#000",
                            backgroundColor: "#000",
                            textStyle: {
                                color: "#000000",
                                fontSize: 13,
                            },
                            position: function (point, _params, _dom, _rect, size) {
                                // 让鼠标位于 tooltip 的下三分之一处
                                return [point[0] + 15, point[1] - size.contentSize[1] * 4 / 5];
                            },
                            formatter: function (e, t, n) {
                                let data = e.data;
                                let context = `
                            <div>
                                <p><b style="font-size:15px;"><span class="tooltip_left">城市：</span><span class="tooltip_right">${data.name}</span></b></p>
                                <p class="tooltip_style"><span class="tooltip_left">开户数：</span><span class="tooltip_right">${data.value}</span></p>
                                ${data.permissionAuth == 1 ? `<p class="tooltip_style"><span class="tooltip_left">新注册公司：</span><span class="tooltip_right">${data.total_companies}</span></p>` : ''}
                                ${data.permissionAuth == 1 ? `<p class="tooltip_style"><span class="tooltip_left">新注册个体户：</span><span class="tooltip_right">${data.total_individuals}</span></p>` : ''}
                                ${data.permissionAuth == 1 ? `<p class="tooltip_style"><span class="tooltip_left">新注册合计：</span><span class="tooltip_right">${data.total_register}</span></p>` : ''}
                                ${data.permissionAuth == 1 ? `<p class="tooltip_style"><span class="tooltip_left">财务公司数量：</span><span class="tooltip_right">${data.total_companycount}</span></p>` : ''}
                                ${data.permissionAuth == 1 ? `<p class="tooltip_style"><span class="tooltip_left">总收入：</span><span class="tooltip_right">${data.total_income}</span></p>` : ''}
                                ${data.permissionAuth == 1 ? `<p class="tooltip_style"><span class="tooltip_left">总基础成本：</span><span class="tooltip_right">${data.total_money}</span></p>` : ''}
                                ${data.permissionAuth == 1 ? `<p class="tooltip_style"><span class="tooltip_left">总基础毛利：</span><span class="tooltip_right">${data.total_netprofit}</span></p>` : ''}
                                ${data.permissionAuth == 1 ? `<p class="tooltip_style"><span class="tooltip_left">合伙人提成：</span><span class="tooltip_right">${data.total_partner_money}</span></p>` : ''}
                                ${data.permissionAuth == 1 ? `<p class="tooltip_style"><span class="tooltip_left">总毛利（已扣合伙人）：</span><span class="tooltip_right">${data.netprofit}</span></p>` : ''}
                                ${data.permissionAuth == 1 ? `<p class="tooltip_style"><span class="tooltip_left">银行单价：</span><span class="tooltip_right">${data.bank_unit_price}</span></p>` : ''}
                                ${data.permissionAuth == 1 ? `<p class="tooltip_style"><span class="tooltip_left">单客基础成本：</span><span class="tooltip_right">${data.unit_cost}</span></p>` : ''}
                                ${data.permissionAuth == 1 ? `<p class="tooltip_style"><span class="tooltip_left">单客基础毛利：</span><span class="tooltip_right">${data.unit_profit}</span></p>` : ''}
                                ${data.permissionAuth == 1 ? `<p class="tooltip_style"><span class="tooltip_left">单客成本（已计合伙人）：</span><span class="tooltip_right">${data.cac}</span></p>` : ''}
                                ${data.permissionAuth == 1 ? `<p class="tooltip_style"><span class="tooltip_left">单客毛利（已扣合伙人）：</span><span class="tooltip_right">${data.cpc}</span></p>` : ''}
                                ${data.permissionAuth == 1 ? `<p class="tooltip_style"><span class="tooltip_left">销售人员成本：</span><span class="tooltip_right">${data.total_sales_personnel_cost}</span></p>` : ''}
                                ${data.permissionAuth == 1 ? `<p class="tooltip_style"><span class="tooltip_left">相关费用：</span><span class="tooltip_right">${data.total_related_expenses}</span></p>` : ''}
                                ${data.permissionAuth == 1 ? `<p class="tooltip_style"><span class="tooltip_left">客服人员成本：</span><span class="tooltip_right">${data.total_customer_personnel_cost}</span></p>` : ''}
                                ${data.permissionAuth == 1 ? `<p class="tooltip_style"><span class="tooltip_left">运营成本合计：</span><span class="tooltip_right">${data.total_operating_cost}</span></p>` : ''}
                                ${data.permissionAuth == 1 ? `<p class="tooltip_style"><span class="tooltip_left">开户项目利润：</span><span class="tooltip_right">${data.profit}</span></p>` : ''}
                            </div>
                            `;
                                return context;
                            },
                        },
                        visualMap: {
                            show: true,
                            left: 26,
                            bottom: 40,
                            showLabel: true,
                            textStyle: {
                                color: "#ffffff",
                            },
                            pieces: [
                                // "#e0f3f8",
                                //         "#ffffbf",
                                //         "#fee090",
                                //         "#fdae61",
                                //         "#f46d43",
                                //         "#d73027",
                                //         "#a50026",
                                {
                                    gte: 1000,
                                    label: ">= 1000",
                                    color: "#a50026",
                                },
                                {
                                    gte: 500,
                                    lt: 999,
                                    label: "500 - 999",
                                    color: "#d73027",
                                },
                                {
                                    gte: 200,
                                    lt: 499,
                                    label: "299 - 499",
                                    color: "#f46d43",
                                },
                                {
                                    gte: 100,
                                    lt: 199,
                                    label: "100 - 499",
                                    color: "#fdae61",
                                },
                                {
                                    gte: 50,
                                    lt: 99,
                                    label: "50 - 99",
                                    color: "#fee090",
                                },
                                {
                                    gte: 1,
                                    lt: 49,
                                    label: "< 50",
                                    color: "#ffffbf",
                                },
                                {
                                    lt: 1,
                                    label: "0",
                                    color: "#e0f3f8",
                                },
                            ],
                        },
                        geo: {
                            map: "provincia",
                            scaleLimit: {
                                min: 1,
                                max: 2,
                            },
                            zoom: 1.2,
                            top: 60,
                            layoutSize: "100%", //保持地图宽高比
                            label: {
                                normal: {
                                    show: false,
                                    fontSize: "12",
                                    color: "rgba(0,0,0,0)",
                                },
                                emphasis: {
                                    show: true,
                                    position: "inside",
                                    textStyle: {
                                        color: "rgba(144,1,34,1)",
                                    },
                                },
                            },
                            itemStyle: {
                                normal: {
                                    //shadowBlur: 50,
                                    //shadowColor: 'rgba(0, 0, 0, 0.2)',
                                    borderColor: "rgba(0, 0, 0, 0.2)",
                                    areaColor: "#1955a4",
                                },
                                emphasis: {
                                    areaColor: "#f2d5ad",
                                    shadowOffsetX: 0,
                                    shadowOffsetY: 0,
                                    borderWidth: 0,
                                },
                            },
                        },
                        series: [
                            {
                                name: "成果预览",
                                type: "map",
                                geoIndex: 0,
                                data: this.provinceList,
                            },
                        ],
                    };

                    this.myChartProvincia.clear();
                    this.myChartProvincia.setOption(options);
                    this.myChartProvincia.resize();
                    let that = this;
                    //地图的点击事件 ，钻取到市我就不举例了，类似的方法，点击事件可以获取到当前点击的省份的数据；
                    this.myChartProvincia.on("click", function (params) {
                        console.log(params, 'paramsparamsparams')
                        if (params.data.bank_count != 0) {
                            // that.dialogTableVisible5 = true;
                            that.selectCity = params;
                            console.log(that.selectCity, 'that.selectCity')
                            that.mapCityShow = true;
                            setTimeout(() => {
                                that.nextGetCityData()
                                that.getMonList()
                                that.getIndex() // 刷新首页数据，传递省份和城市参数
                            }, 600)
                        }

                    });
                    this.tableLoading = false;
                } else {
                    this.tableLoading = false;
                }
            });
        },

        // 城市数据
        async get_bank_type() {
            const res = await get_bank_type({})
            if (res.data.code == 1) {
                let obj = {}
                for (let item of res.data.data) {
                    if (item.code) {
                        this.cityOptions.legend.data.push(item.name)
                        obj[item.code] = {
                            name: item.name,
                            code: item.code,
                            color: item.color
                        }
                    }
                }
                this.bankDictionary = obj
            }
        },

        // 变形银行排名
        morphRanking2() {
            const list = mapBanksListData.sort((a, b) => a.count - b.count)
            let sData = []
            for (let item of list) {
                sData.push({ value: item.count, name: item.name, itemStyle: { color: item.color } })
            }
            var option = {
                legend: {
                    textStyle: {
                        color: '#ffffff',
                    },
                    top: '10'
                },
                toolbox: {
                    show: true,
                    feature: {
                        // mark: { show: true },
                        // dataView: { show: true, readOnly: false },
                        // restore: { show: true },
                        // saveAsImage: { show: true }
                    }
                },
                tooltip: {},
                series: [
                    {
                        name: '',
                        type: 'pie',
                        radius: [50, 250],
                        center: ['50%', '50%'],
                        roseType: 'area',
                        itemStyle: {
                            borderRadius: 8
                        },
                        label: {
                            color: '#ffffff'     // 文字颜色白色
                        },
                        data: sData
                    }
                ]
            };

            this.myChartCtiy.clear()
            this.$nextTick(() => {
                this.myChartCtiy.setOption(option, true);
            })
        },

        // 变形网点排名
        morphRanking() {
            const list = mapBankListData.sort((a, b) => a.value[2] - b.value[2])
            let yData = []
            let sData = []
            for (let item of list) {
                yData.push(item.name)
                sData.push({ value: item.value[2], color: item.color })
            }
            var option = {
                title: {
                    text: ''
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: { show: false },
                xAxis: {
                    type: 'value',
                    boundaryGap: [0, 0.01],
                    axisLabel: {
                        color: '#ffffff'
                    }
                },
                yAxis: {
                    type: 'category',
                    data: yData,
                    axisLabel: {
                        color: '#ffffff',
                        formatter: function (value) {
                            console.log(value)
                            return value.length > 8 ? value.slice(0, 8) + '...' : value;
                        }
                    }
                },
                grid: {
                    left: '112px'   // 增加左侧空白，防止长标签被裁剪
                },
                series: [
                    {
                        name: '开户数',
                        type: 'bar',
                        itemStyle: {
                            color: function (param) {
                                return param.data.color || '#319c8b'
                            }
                        },
                        data: sData
                    }
                ]
            };
            if (list.length > 20) {
                option.dataZoom = [
                    {
                        type: 'slider',
                        show: true,
                        yAxisIndex: [0], // 控制第一个Y轴
                        start: 100,
                        end: 70
                    }
                ]
            }

            this.myChartCtiy.clear()
            this.$nextTick(() => {
                this.myChartCtiy.setOption(option, true);
            })
        },

        async morphMap() {
            const res = mapBankRes
            this.cityOptions.series = []
            mapBankListData = []
            mapBanksListData = []
            for (let key in res.data.data) {
                if (res.data.data[key].length > 0) {
                    let mapBanksListDataItem = {
                        count: 0,
                        name: this.bankDictionary[key].name,
                        color: this.bankDictionary[key].color,
                    }
                    let arr = []
                    for (let val in res.data.data[key]) {
                        let obj = {
                            name: res.data.data[key][val].bank_name,
                            value: [res.data.data[key][val].lng, res.data.data[key][val].lat, res.data.data[key][val].count],
                            color: this.bankDictionary[key].color
                        }
                        mapBanksListDataItem.count += res.data.data[key][val].count
                        arr.push(obj)
                    }
                    mapBanksListData.push(mapBanksListDataItem)
                    mapBankListData.push(...arr)
                    this.cityOptions.series.push({
                        name: this.bankDictionary[key].name,
                        data: arr,
                        type: 'scatter',
                        coordinateSystem: 'geo',
                        encode: {
                            value: 2
                        },
                        symbolSize: 20,
                        label: {
                            formatter: function (params) {
                                return params.data.value[2];
                            },
                            position: 'right',
                            show: true,
                        },
                        itemStyle: {
                            color: this.bankDictionary[key].color
                        },
                        emphasis: {
                            label: {
                                show: false
                            }
                        }
                    })

                }
                // console.log(this.cityOptions.series)
            }

            // console.log(cityMap, 'cityMap')
            const cityId = cityMap[this.selectCity.name];
            // console.log(cityId, 'cityId')
            // this.cityJSON = require('../../assets/json/geometryCity/' + cityId + '.json')
            const json = await getMapJson({
                city: cityId,
            })

            this.cityJSON = JSON.parse(json.data.data)

            this.$echarts.registerMap(this.selectCity.name, this.cityJSON)

            this.cityOptions.geo.map = this.selectCity.name
            console.log('生成地图', this.myChartCtiy)
            if (this.myChartCtiy) {
                this.myChartCtiy.clear()
                this.myChartCtiy = null
            }

            this.myChartCtiy = this.$echarts.init(document.getElementById('mapCity'))
            this.myChartCtiy.setOption(this.cityOptions);



            //this.cityList = res.data.data
        },

        mapCityShowTypeInput(i) {
            if (i == 'map') {
                this.morphMap()
            } else if (i == 'branch') {
                this.morphRanking()
            } else if (i == 'bank') {
                this.morphRanking2()
            }
        },

        // 获取市一级数据
        async getCityData() {
            this.tableLoading2 = true
            console.log("获取市级数据，展示在弹窗上");
            let params = {
                city: this.selectCity.name
            }
            if (this.selectDate2 && this.selectDate2.length > 0) {
                params.start_date = this.selectDate2[0]
                params.end_date = this.selectDate2[1]
            }
            const res = await getCityBankData_new(params)
            if (res.data.code == 1) {
                mapBankRes = res
                this.morphMap()
            }
        },


        // 获取对于时间范围用户活跃数据
        getMonList() {
            this.loading2 = true
            this.tableLoading3 = true
            let obj = {}
            if (this.selectDate2) {
                obj.start_date = this.selectDate2[0]
                obj.end_date = this.selectDate2[1]
            }
            if (this.mapProvinciaShow) {
                for (let item of region) {
                    if (item.name.includes(this.selectProvincia.name)) obj.province = item.name
                }
            }
            if (this.mapCityShow) obj.city = this.selectCity.name

            getKaihuMonthCityList(obj).then((res) => {
                this.loading2 = false
                let xData = [];
                let yuyue = []
                let day_yuyue = []
                res.data.data.forEach(val => {
                    xData.push(val.date);
                    yuyue.push(val.yuyue)
                    day_yuyue.push(val.day_yuyue)
                })
                lineOpiton2.xAxis.data = xData;
                lineOpiton2.series[0].data = yuyue;
                lineOpiton2.series[1].data = day_yuyue;
                this.$echarts
                    .init(document.getElementById("monActive"))
                    .setOption(lineOpiton2);
            });
            this.getCityTable()
        },

        getCityTable() {
            let obj = {}
            if (this.selectDate2) {
                obj.start_date = this.selectDate2[0]
                obj.end_date = this.selectDate2[1]
            }
            if (this.mapProvinciaShow) {
                for (let item of region) {
                    if (item.name.includes(this.selectProvincia.name)) obj.province = item.name
                }
            }
            if (this.mapCityShow) obj.city = this.selectCity.name
            // province: this.cityValue[0],
            // city: this.cityValue[1]
            getCityDataNew(obj).then(res => {
                console.log(res)
                this.originalData = res.data.data
                this.processData()
            })
        },

        // 处理原始数据，转换为树形表格所需格式
        processData() {
            // 获取所有日期列
            const dates = [...new Set(this.originalData.map(item => item.date))].sort();
            this.dateColumns = dates;

            // 按省份分组
            const provinceMap = {};

            // 首先创建省份节点
            this.originalData.forEach(item => {
                const province = item.province;
                if (!provinceMap[province]) {
                    provinceMap[province] = {
                        id: province,
                        name: province,
                        type: 'province',
                        children: [],
                        // hasChildren: true
                    };

                    // 初始化每个日期列的值为0
                    dates.forEach(date => {
                        provinceMap[province][date] = 0;
                    });
                }
            });

            // 然后处理每个日期的数据
            this.originalData.forEach(item => {
                const province = item.province;

                // 设置省份在当前日期的值
                provinceMap[province][item.date] = item.data;

                // 处理城市数据
                item.citydata.forEach(cityItem => {
                    let city = provinceMap[province].children.find(c => c.name === cityItem.city);
                    if (!city) {
                        city = {
                            id: `${province}-${cityItem.city}`,
                            name: cityItem.city,
                            type: 'city',
                            parentId: province
                        };

                        // 初始化每个日期列的值为0
                        dates.forEach(date => {
                            city[date] = 0;
                        });

                        provinceMap[province].children.push(city);
                    }

                    // 设置城市在当前日期的值
                    city[item.date] = cityItem.data;
                });
            });

            // 转换为数组
            this.tableData = Object.values(provinceMap);

            // 打印调试信息
            // console.log("处理后的表格数据:", this.tableData);
            this.tableLoading3 = false
        },

        clickData(type) {
            this.dataType = type;
            this.dialogTableVisible = true;
            let params = {
                type: type,
            };
            this.getPage(this.page, params);
        },


        //获取首页数据
        getIndex() {
            let params = {};
            // 根据地图状态传递省份和城市参数
            if (this.mapCityShow && this.selectCity.name) {
                // 城市级别：传递省份和城市
                params.province = this.selectProvincia.name;
                // 去掉城市名称末尾的"市"字
                params.city = this.selectCity.name.replace(/市$/, '');
            } else if (this.mapProvinciaShow && this.selectProvincia.name) {
                // 省份级别：只传递省份
                params.province = this.selectProvincia.name;
            }
            // 全国级别：不传参数

            getScreenIndex(params).then((res) => {
                this.indexObj = res.data.data;
            });
        },

        getWebSocket() {
            this.$goeasy.connect({
                onSuccess: function () {
                    //连接成功
                    console.log("GoEasy connect successfully."); //连接成功
                },
                onFailed: function (error) {
                    //连接失败
                    console.log(
                        "Failed to connect GoEasy, code:" +
                        error.code +
                        ",error:" +
                        error.content
                    );
                },
                onProgress: function (attempts) {
                    //连接或自动重连中
                    console.log("GoEasy is connecting", attempts);
                },
            });
            let pubsub = this.$goeasy.pubsub;
            let _that = this;
            pubsub.subscribe({
                channel: "screen_channel", //替换为您自己的channel
                onMessage: function (message) {
                    console.log("是否能从服务端主动接收到消息");
                    _that.getMap();
                    _that.getIndex();
                    // _that.getPageClick();
                    _that.scrollView = !_that.scrollView;
                },
                onSuccess: function () {
                    console.log("Channel订阅成功。");
                },
                onFailed: function (error) {
                    console.log(
                        "Channel订阅失败, 错误编码：" +
                        error.code +
                        " 错误信息：" +
                        error.content
                    );
                },
            });
        },
    },
};
</script>

<style lang="scss">
@import "@/styles/home.scss";
@import "@/styles/common.scss";

.index_table {
    background-color: #081832;
    z-index: 1000;

    // transition: all 0.4s;
    .bigicon {
        height: 0;
        position: relative;
        z-index: 888;
        top: -12px;
        left: -12px;

        i {
            font-size: 24px;
            color: #ffffff;
            cursor: pointer;
        }
    }
}

.header-cell {
    color: #61d2f7 !important;
    font-size: 14px;
    font-weight: 600;
    height: 48px;
    background-color: #072951 !important;
    box-shadow: -10px 0px 15px #034c6a inset, 10px 0px 15px #034c6a inset;
}

.row-cell {
    color: #fff !important;
    background-color: #072951 !important;
}

.row-cells {
    color: #fff !important;
    background-color: #072951 !important;
    box-shadow: -10px 0px 15px #034c6a inset, 10px 0px 15px #034c6a inset;
}

.table-header {
    color: #fff;
    width: 95%;
    margin-left: 2.5%;
    text-align: center;
    padding-top: 20px;
    font-size: 15px;
    padding-bottom: 14px;
    border-bottom: 1px solid #70b4eb;
}

.tooltip_left {
    color: #FDDFB1;
}

.tooltip_right {
    color: #D37F3A;
}
</style>
